import styled from 'styled-components';

export const JobDetailsWrapper = styled.div`
  & > div:nth-child(2) {
    margin: 20px 0;
  }

  & > div:nth-child(5) {
    margin-bottom: 20px;
  }
`;
